import axios from 'axios';
import { REACT_APP_API } from '../../../config';

export async function getPaginatedList({ search, cancelToken }) {
  const results = await axios.get(
      `${REACT_APP_API}/dictionary/getPaginatedList/${search}`,
      { cancelToken }
    );
  return results.data.data;
}
